import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  container: {
    maxWidth: 860,
    margin: '0 auto',
    marginTop: 32,
    [theme.breakpoints.down('sm')]: {
      width: 'unset',
      maxWidth: 'unset',
      marginLeft: -16,
      marginRight: -16,
    },
  },
  depositLimitButton: {
    display: 'inline-flex',
    top: -3,
  }
}), { name: 'IkeOrIkze' });
